if (!customElements.get('ow-select')) {
  customElements.define(
    'ow-select',
    class OwSelect extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}
